import { requireAuth } from '@tcap/data-router/utils/requireAuth';
import { traceBoot } from '@tcap/data-router/utils/bootTrace';

export async function protectedLoader({ request }) {
    traceBoot('protected-loader.start', {
        pathname: new URL(request.url).pathname,
    });
    const result = await requireAuth(request);
    traceBoot('protected-loader.end', {
        pathname: new URL(request.url).pathname,
    });
    return result;
}
